import type { LC_RoleMemberItem, RoleMember } from './roleMembers.types';


export function mapRoleMember(item: LC_RoleMemberItem): RoleMember {
  return {
    employeeId: item.employeeId,
    employeeName: item.employeeName ?? '',
    employeeTaxIdentificationNumber: item.employeeTaxIdentificationNumber ?? '',
  };
}
